import { Chart } from "@scuf/charts";
import { Card } from "@scuf/common";
import { useEffect, useState } from "react";
import { TostadorFetching } from "../../../class/fetchTostador";
import { plotBackground } from "../../../config/colors";
import { useDate } from "../../../hooks/useDate";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";

export default function PerfilCorrienteBombasBBA() {
  const initialFetch = new TostadorFetching().setIdSeccion(2).setSecuencia(39);

  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  // Custom hook que nos ayuda a extraer la fecha inicial y final
  const { setDateHook, fullDate } = useDate();

  const [corrienteBombaBBA01, setCorrienteBombaBBA01] = useState(defaultObject);
  const [corrienteBombaBBA02, setCorrienteBombaBBA02] = useState(defaultObject);
  const [corrienteBombaBBA03, setCorrienteBombaBBA03] = useState(defaultObject);
  const [corrienteBombaBBA11, setCorrienteBombaBBA11] = useState(defaultObject);
  const [corrienteBombaBBA12, setCorrienteBombaBBA12] = useState(defaultObject);
  const [corrienteBombaBBA13, setCorrienteBombaBBA13] = useState(defaultObject);

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
      const { data } = await getValoresPeriodo(initialFetch);

      populateCorrienteBombaBBA01(data);
      populateCorrienteBombaBBA02(data);
      populateCorrienteBombaBBA03(data);
      populateCorrienteBombaBBA11(data);
      populateCorrienteBombaBBA12(data);
      populateCorrienteBombaBBA13(data);
      setDateHook(data, "Corriente Bomba BBA01");
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateCorrienteBombaBBA13(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Corriente Bomba BBA13"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setCorrienteBombaBBA13({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCorrienteBombaBBA12(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Corriente Bomba BBA12"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setCorrienteBombaBBA12({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCorrienteBombaBBA11(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Corriente Bomba BBA11"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setCorrienteBombaBBA11({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCorrienteBombaBBA03(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Corriente Bomba BBA03"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setCorrienteBombaBBA03({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCorrienteBombaBBA02(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Corriente Bomba BBA02"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setCorrienteBombaBBA02({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCorrienteBombaBBA01(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Corriente Bomba BBA01"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setCorrienteBombaBBA01({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil de Corriente en Bombas BBA"}
            subtitle={"Periodo " + fullDate()}
          >
            {/** -------------------------------- Corriente Bomba BBA01 --------------------------------------- */}
            <Chart.Line
              name="Corriente Bomba BBA01"
              data={corrienteBombaBBA01.value}
              yAxis={0}
            />

            {/** -------------------------------- Corriente Bomba BBA02 --------------------------------------- */}
            <Chart.Line
              name="Corriente Bomba BBA02"
              data={corrienteBombaBBA02.value}
              yAxis={0}
            />

            {/** -------------------------------- Corriente Bomba BBA03 --------------------------------------- */}
            <Chart.Line
              name="Corriente Bomba BBA03"
              data={corrienteBombaBBA03.value}
              yAxis={0}
            />

            {/** -------------------------------- Corriente Bomba BBA11 --------------------------------------- */}
            <Chart.Line
              name="Corriente Bomba BBA11"
              data={corrienteBombaBBA11.value}
              yAxis={0}
            />

            {/** -------------------------------- Corriente Bomba BBA12 --------------------------------------- */}
            <Chart.Line
              name="Corriente Bomba BBA12"
              data={corrienteBombaBBA12.value}
              yAxis={0}
            />

            {/** -------------------------------- Corriente Bomba BBA13 --------------------------------------- */}
            <Chart.Line
              name="Corriente Bomba BBA13"
              data={corrienteBombaBBA13.value}
              yAxis={0}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={corrienteBombaBBA01.fecha} />

            <Chart.YAxis
              labelSuffix=" A"
              title="Corriente"
              lineWidth={2}
              lineColor="white"
              min={0}
            />
            <Chart.YAxis
              lineWidth={2}
              lineColor="white"
              opposite={true}
              min={0}
            />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
